<div class="content-info">
    <div class="content-title">
      <h3 class="title">Reorder Requests</h3>
      <div class="title-actions d-flex align-items-center ">
        <!-- <label class="me-2">Location:</label> -->
        <div class="form-group">
          <select class="form-select form-control" [(ngModel)]="selectedLocationId" (change)="onLocationChange()">
            <option value="">All Locations</option>
            @for (loc of allLocations; track loc.id) {
              <option [value]="loc.id">{{ loc.name }}</option>
            }
          </select>
        </div>
      </div>
    </div>
  
    <div class="common-table">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>SKU</th>
              <th>Location</th>
              <th>Quantity</th>
              <th>Status</th>
              <th>Requested At</th>
            </tr>
          </thead>
          <tbody>
            @for (r of reorderRequests; track r.id) {
              <tr>
                <td>{{ reorderRequests.indexOf(r) + 1 }}</td>
                <td>{{ r.product.name }}</td>
                <td>{{ r.product.sku }}</td>
                <td>{{ r.location.name }}</td>
                <td>{{ r.quantityRequested }}</td>
                <td>{{ r.status }}</td>
                <td>{{ r.createdAt}}</td>
              </tr>
            }
          </tbody>
        </table>
        </div>

 
    </div>
  </div>
  